module.exports = __webpack_public_path__ + "img/etape1.6d80423f.png";